import ApiClient from '../../../api/ApiClient';
import {
  ApiFilterCriteria,
  CollectionResponse,
  Exam,
  Repository,
} from '../../../types';
import { parseCriteria } from '../../../utils/common';

class PrioExamRepository implements Repository<Exam> {
  findBy(
    criteria?: ApiFilterCriteria,
    page?: number,
    perPage?: number,
  ): Promise<CollectionResponse<Exam>> {
    const params = parseCriteria(criteria, {
      page: page || 0,
      perPage: perPage || 10,
    });

    return ApiClient.get(`/api/v1/exams-with-prio`, params);
  }
}

export default PrioExamRepository;
